import script from "./DatasetFilterUI.vue?vue&type=script&setup=true&lang=js"
export * from "./DatasetFilterUI.vue?vue&type=script&setup=true&lang=js"

import "./DatasetFilterUI.vue?vue&type=style&index=0&id=6b246a21&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b246a21"]])

export default __exports__